import * as angular from 'angular';

interface IOffClickScope {
    offClick: () => any;
    offClickIf: () => boolean;
}

function offClick($document: ng.IDocumentService, $timeout: ng.ITimeoutService) {

    function targetInFilter(target: Element, filter: string) {
        if (!target || !filter) {
            return false;
        }
        var elms = angular.element(document.querySelectorAll(filter));
        var elmsLen = elms.length;
        for (var i = 0; i < elmsLen; ++i) {
            if (elms[i].contains(target)) {
                return true;
            }
        }
        return false;
    }

    return {
        restrict: 'A',
        scope: {
            offClick: '&',
            offClickIf: '&'
        },
        link: function (scope: ng.IScope & IOffClickScope, elm: JQLite, attr: ng.IAttributes) {
            function handler(event: JQueryEventObject) {
                // This filters out artificial click events. Example: If you hit enter on a form to submit it, an
                // artificial click event gets triggered on the form's submit button.
                if (event.pageX === 0 && event.pageY === 0) {
                    return;
                }

                var target = event.target || event.srcElement;
                if (!(elm[0].contains(target) || targetInFilter(target, attr.offClickFilter))) {
                    scope.$apply(scope.offClick());
                }
            }

            if (attr.offClickIf) {
                scope.$watch(scope.offClickIf, function (newVal: boolean, oldVal: boolean) {
                    if (newVal && !oldVal) {
                        $timeout(function () {
                            $document.on('click touchstart', handler);
                        });
                    } else if (!newVal) {
                        $document.off('click touchstart', handler);
                    }
                }
                );
            } else {
                $document.on('click touchstart', handler);
            }

            scope.$on('$destroy', function () {
                $document.off('click touchstart', handler);
            });
        }
    };
}

angular
    .module('app.common')
    .directive('offClick', offClick);

offClick.$inject = ['$document', '$timeout'];



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.common/modules/common/directives/off-click.directive.ts